import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import "../../../../css/salesorder.css";
import { GridLayout } from "../../../../../common/GridLayout";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
const CustomerTabResult = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "032223b3-ed4c-4c7f-a081-f97662f3d653";
       const [currentLayout, setCurrentLayout]= useState("Default");
    const saveState = useCallback((state) => {GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);

    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
             ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="single" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <FilterRow visible={true} />
                <Column dataField="recordNumber" caption='Record#' ></Column>
                <Column dataField="identityid" caption='Customer' ></Column>
                <Column dataField="name" caption='Name' ></Column>
                <Column dataField="address1" caption='Address -1' ></Column>
                <Column dataField="address2" caption='Address -2' ></Column>
                <Column dataField="city" caption='City' ></Column>
                <Column dataField="state" caption='State' ></Column>
                <Column dataField="zip" caption='Zip' ></Column>
                <Column dataField="country" caption='Country' ></Column>
                <Column dataField="telephone1" caption='Telephone1' ></Column>


                <Column dataField="companyid" caption="Company ID" visible={false} />
                <Column dataField="billingCycle" caption="Billing Cycle" visible={false} />
                <Column dataField="module" caption="Module" visible={false} />
                <Column dataField="recordtype" caption="Record Type" visible={false} />
                <Column dataField="idmastercomment" caption="ID Master Comment" visible={false} />
                <Column dataField="idgroup" caption="ID Group" visible={false} />
                <Column dataField="idsubgroup" caption="ID Subgroup" visible={false} />
                <Column dataField="reference1" caption="Reference 1" visible={false} />
                <Column dataField="reference2" caption="Reference 2" visible={false} />
                <Column dataField="rprofile" caption="R Profile" visible={false} />
                <Column dataField="idtype" caption="ID Type" visible={false} />
                <Column dataField="contactid" caption="Contact ID" visible={false} />
                <Column dataField="contactname" caption="Contact Name" visible={false} />
                <Column dataField="addressrowid" caption="Address Row ID" visible={false} />
                <Column dataField="addresskeysequence" caption="Address Key Sequence" visible={false} />
                <Column dataField="addressname" caption="Address Name" visible={false} />
                <Column dataField="alternatename" caption="Alternate Name" visible={false} />
                <Column dataField="latitude" caption="Latitude" visible={false} />
                <Column dataField="longitude" caption="Longitude" visible={false} />
                <Column dataField="fax1" caption="Fax 1" visible={false} />
                <Column dataField="fax2" caption="Fax 2" visible={false} />
                <Column dataField="modem1" caption="Modem 1" visible={false} />
                <Column dataField="modem2" caption="Modem 2" visible={false} />
                <Column dataField="cellphone1" caption="Cell Phone 1" visible={false} />
                <Column dataField="cellphone2" caption="Cell Phone 2" visible={false} />
                <Column dataField="pager1" caption="Pager 1" visible={false} />
                <Column dataField="pager2" caption="Pager 2" visible={false} />
                <Column dataField="emailaddress1" caption="Email Address 1" visible={false} />
                <Column dataField="emailaddress2" caption="Email Address 2" visible={false} />
                <Column dataField="websiteaddress1" caption="Website Address 1" visible={false} />
                <Column dataField="websiteaddress2" caption="Website Address 2" visible={false} />
                <Column dataField="addressmemo" caption="Address Memo" visible={false} />
                <Column dataField="status" caption="Status" visible={false} />

                <Column dataField="userDefinedQuantity1 " caption="Quantity1" visible={false}></Column>
                <Column dataField="userDefinedQuantity2 " caption="Quantity2" visible={false}></Column>
                <Column dataField="userDefinedQuantity3 " caption="Quantity3" visible={false}></Column>
                <Column dataField="userDefinedQuantity4 " caption="Quantity4" visible={false}></Column>
                <Column dataField="userDefinedQuantity5 " caption="Quantity5" visible={false}></Column>
                <Column dataField="userDefinedQuantity6 " caption="Quantity6" visible={false}></Column>
                <Column dataField="userDefinedQuantity7 " caption="Quantity7" visible={false}></Column>
                <Column dataField="userDefinedQuantity8 " caption="Quantity8" visible={false}></Column>
                <Column dataField="userDefinedQuantity9 " caption="Quantity9" visible={false}></Column>
                <Column dataField="userDefinedQuantity10" caption="Quantity10" visible={false}></Column>
                <Column dataField="userDefinedReference1" caption="Reference1" visible={false}></Column>
                <Column dataField="userDefinedReference2" caption="Reference2" visible={false}></Column>
                <Column dataField="userDefinedReference3" caption="Reference3" visible={false}></Column>
                <Column dataField="userDefinedReference4" caption="Reference4" visible={false}></Column>
                <Column dataField="userDefinedReference5" caption="Reference5" visible={false}></Column>
                <Column dataField="userDefinedReference6" caption="Reference6" visible={false}></Column>
                <Column dataField="userDefinedReference7" caption="Reference7" visible={false}></Column>
                <Column dataField="userDefinedReference8" caption="Reference8" visible={false}></Column>
                <Column dataField="userDefinedReference9" caption="Reference9" visible={false}></Column>
                <Column dataField="userDefinedReference10" caption="Reference10" visible={false}></Column>

                <Column dataField="userDefinedDate1 " caption="Date1" dataType="date" visible={false}></Column>
                <Column dataField="userDefinedDate2 " caption="Date2" dataType="date" visible={false}></Column>
                <Column dataField="userDefinedDate3 " caption="Date3" dataType="date" visible={false}></Column>
                <Column dataField="userDefinedDate4 " caption="Date4" dataType="date" visible={false}></Column>
                <Column dataField="userDefinedDate5 " caption="Date5" dataType="date" visible={false}></Column>
                <Column dataField="userDefinedDate6 " caption="Date6" dataType="date" visible={false}></Column>
                <Column dataField="userDefinedDate7 " caption="Date7" dataType="date" visible={false}></Column>
                <Column dataField="userDefinedDate8 " caption="Date8" dataType="date" visible={false}></Column>
                <Column dataField="userDefinedDate9 " caption="Date9" dataType="date" visible={false}></Column>
                <Column dataField="userDefinedDate10" caption="Date10" dataType="date" visible={false}></Column>

                <Column dataField="userDefinedCode1" caption="Code1" visible={false}> </Column>
                <Column dataField="userDefinedCode2 " caption="Code2" visible={false}></Column>
                <Column dataField="userDefinedCode3 " caption="Code3" visible={false}></Column>
                <Column dataField="userDefinedCode4 " caption="Code4" visible={false}></Column>
                <Column dataField="userDefinedCode5 " caption="Code5" visible={false}></Column>
                <Column dataField="userDefinedCode6 " caption="Code6" visible={false}></Column>
                <Column dataField="userDefinedCode7 " caption="Code7" visible={false}></Column>
                <Column dataField="userDefinedCode8 " caption="Code8" visible={false}></Column>
                <Column dataField="userDefinedCode9 " caption="Code9" visible={false}></Column>
                <Column dataField="userDefinedCode10" caption="Code10" visible={false}></Column>

                <Toolbar>
                <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(CustomerTabResult);